/**
 * Invoice Model - Processes API responses for invoice data
 */

export const getInvoices = (response) => {
  if (response && response.data && response.data.success === true) {
    const invoices = Array.isArray(response.data.data)
      ? response.data.data.map((inv) => ({
          id: inv.id || null,
          slack: inv.slack || '',
          store_id: inv.store_id || null,
          order_id: inv.order_id || null,
          parent_po_id: inv.parent_po_id || null,
          invoice_number: inv.invoice_number || '',
          invoice_reference: inv.invoice_reference || '',
          invoice_date: inv.invoice_date || '',
          invoice_due_date: inv.invoice_due_date || '',
          bill_to: inv.bill_to || '',
          bill_to_id: inv.bill_to_id || null,
          bill_to_code: inv.bill_to_code || '',
          bill_to_name: inv.bill_to_name || '',
          bill_to_email: inv.bill_to_email || '',
          bill_to_contact: inv.bill_to_contact || '',
          bill_to_address: inv.bill_to_address || '',
          currency_name: inv.currency_name || '',
          currency_code: inv.currency_code || '',
          tax_option_id: inv.tax_option_id || null,
          subtotal_excluding_tax: inv.subtotal_excluding_tax || '0',
          total_discount_amount: inv.total_discount_amount || '0',
          total_after_discount: inv.total_after_discount || '0',
          total_tax_amount: inv.total_tax_amount || '0',
          shipping_charge: inv.shipping_charge || '0',
          packing_charge: inv.packing_charge || '0',
          total_order_amount: inv.total_order_amount || '0',
          total_order_amount_rounded: inv.total_order_amount_rounded || '0',
          notes: inv.notes || null,
          terms: inv.terms || null,
          status: inv.status ?? 0,
          reverse_charge_applicable: Boolean(inv.reverse_charge_applicable),
          created_at: inv.created_at || '',
          updated_at: inv.updated_at || '',
          createdAt: inv.createdAt || inv.created_at || '',
          updatedAt: inv.updatedAt || inv.updated_at || '',
          created_by: inv.created_by,
          updated_by: inv.updated_by,
          invoice_pdf_url: inv.invoice_pdf_url || null,
          store: inv.store ? {
            id: inv.store.id || null,
            slack: inv.store.slack || '',
            store_code: inv.store.store_code || '',
            name: inv.store.name || '',
            tax_number: inv.store.tax_number || '',
            address: inv.store.address || '',
            pincode: inv.store.pincode || '',
            primary_contact: inv.store.primary_contact || '',
            secondary_contact: inv.store.secondary_contact || null,
            primary_email: inv.store.primary_email || '',
            secondary_email: inv.store.secondary_email || null,
            country: inv.store.country ? {
              id: inv.store.country.id || null,
              name: inv.store.country.name || '',
              code: inv.store.country.code || ''
            } : null,
            status: inv.store.status ?? 0,
            status_data: inv.store.status_data ? {
              id: inv.store.status_data.id || null,
              key: inv.store.status_data.key || '',
              value: inv.store.status_data.value || '',
              value_constant: inv.store.status_data.value_constant || '',
              label: inv.store.status_data.label || '',
              color: inv.store.status_data.color || ''
            } : null,
            invoice_type: inv.store.invoice_type || '',
            invoice_format: inv.store.invoice_format || '',
            invoice_sequence_digits: inv.store.invoice_sequence_digits || '',
            invoice_start_number: inv.store.invoice_start_number || '',
            invoice_reset_sequence: inv.store.invoice_reset_sequence || '',
            restaurant_mode: inv.store.restaurant_mode ?? 0,
            digital_menu_enabled: inv.store.digital_menu_enabled ?? 0,
            is_primary: inv.store.is_primary ?? false,
            store_type: inv.store.store_type || '',
            is_procurement_hub: inv.store.is_procurement_hub ?? 0,
            can_sell: inv.store.can_sell ?? false,
            org_id: inv.store.org_id || null,
            country_id: inv.store.country_id || null,
            state_code: inv.store.state_code || '',
            state: inv.store.state || ''
          } : null,
          tax_option: inv.tax_option ? {
            id: inv.tax_option.id || null,
            tax_option_constant: inv.tax_option.tax_option_constant || '',
            label: inv.tax_option.label || '',
            description: inv.tax_option.description || '',
            status: inv.tax_option.status ?? 0
          } : null,
          status_data: inv.status_data ? {
            id: inv.status_data.id || null,
            key: inv.status_data.key || '',
            value: inv.status_data.value || '',
            value_constant: inv.status_data.value_constant || '',
            label: inv.status_data.label || '',
            color: inv.status_data.color || '',
            status: inv.status_data.status ?? 0
          } : null,
          created_by_user: inv.created_by && typeof inv.created_by === 'object' ? {
            id: inv.created_by.id || null,
            username: inv.created_by.username || '',
            email: inv.created_by.email || ''
          } : null,
          updated_by_user: inv.updated_by && typeof inv.updated_by === 'object' ? {
            id: inv.updated_by.id || null,
            username: inv.updated_by.username || '',
            email: inv.updated_by.email || ''
          } : null,
          customer: inv.customer || null,
          supplier: inv.supplier || null,
          pending_payments: inv.pending_payments || {},
          order: inv.order || null,
          products: Array.isArray(inv.products) ? inv.products.map((p) => ({
            id: p.id || null,
            slack: p.slack || '',
            invoice_id: p.invoice_id || null,
            product_id: p.product_id || null,
            product_slack: p.product_slack || '',
            product_code: p.product_code || '',
            name: p.name || '',
            quantity: p.quantity || '0',
            amount_excluding_tax: p.amount_excluding_tax || '0',
            discount_percentage: p.discount_percentage || '0',
            tax_type: p.tax_type || '',
            tax_percentage: p.tax_percentage || '0',
            discount_amount: p.discount_amount || '0',
            total_after_discount: p.total_after_discount || '0',
            tax_amount: p.tax_amount || '0',
            tax_components: Array.isArray(p.tax_components) ? p.tax_components : [],
            total_amount: p.total_amount || '0',
            status: p.status ?? 0,
            meta_data: Array.isArray(p.meta_data) ? p.meta_data : []
          })) : [],
          transactions: Array.isArray(inv.transactions) ? inv.transactions.map((t) => ({
            id: t.id || null,
            slack: t.slack || '',
            store_id: t.store_id || null,
            transaction_code: t.transaction_code || '',
            account_id: t.account_id || null,
            transaction_type: t.transaction_type ?? null,
            payment_method_id: t.payment_method_id || null,
            payment_method: t.payment_method || '',
            bill_to: t.bill_to || '',
            bill_to_id: t.bill_to_id || null,
            bill_to_name: t.bill_to_name || '',
            bill_to_contact: t.bill_to_contact || '',
            bill_to_address: t.bill_to_address || '',
            currency_code: t.currency_code || '',
            amount: t.amount || '0',
            notes: t.notes || '',
            pg_transaction_id: t.pg_transaction_id || '',
            pg_transaction_status: t.pg_transaction_status || '',
            is_bill_posting: t.is_bill_posting ?? 0,
            pms_settlement_status: t.pms_settlement_status || null,
            payment_status: t.payment_status ?? 0,
            transaction_reference: t.transaction_reference || null,
            transaction_date: t.transaction_date || '',
            transaction_merged: t.transaction_merged ?? 0,
            merged_from: t.merged_from || null,
            merged_to: t.merged_to || null,
            created_by: t.created_by || null,
            updated_by: t.updated_by || null,
            createdAt: t.createdAt || '',
            updatedAt: t.updatedAt || ''
          })) : [],
          related_entities: inv.related_entities || null
        }))
      : []

    return {
      success: true,
      total: response.data.total || invoices.length,
      data: invoices
    }
  }
  return {
    success: false,
    message: response?.data?.message || 'Failed to fetch invoices',
    data: []
  }
}

export const mapBillToList = (response) => {
  if (response && response.data && response.data.success === true) {
    const data = Array.isArray(response.data.data) ? response.data.data : []
    // Normalize to { slack, label }
    const normalized = data.map((item) => ({
      slack:
        item.slack ||
        item.id ||
        item.customer_slack ||
        item.supplier_slack ||
        item.code ||
        item.value ||
        '',
      label:
        item.label ||
        item.name ||
        item.customer_name ||
        item.supplier_name ||
        item.title ||
        item.display ||
        '',
      reverse_charge_applicable: Boolean(item.reverse_charge_applicable)
    }))
    return { success: true, data: normalized }
  }
  return { success: false, data: [] }
}

export const mapProductsForInvoice = (response) => {
  if (
    response &&
    response.data &&
    (response.data.success === true || Array.isArray(response.data))
  ) {
    const list = response.data.data || response.data
    const products = Array.isArray(list)
      ? list.map((p) => ({
          product_slack: p.product_slack,
          product_code: p.product_code,
          label: p.label || p.name,
          purchase_amount_excluding_tax: p.purchase_amount_excluding_tax,
          tax_percentage: p.tax_percentage,
          tax_type: p.tax_type,
          Supplier: p.Supplier || null,
          meta_data: p?.meta_data || []
        }))
      : []
    return { success: true, data: products }
  }
  return { success: false, data: [] }
}

export const createInvoice = (response) => {
  if (response && response.data) {
    return {
      success: response.data.success === true,
      message: response.data.message || 'Invoice created successfully',
      data: response.data.data || null
    }
  }
  return { success: false, message: 'Failed to create invoice', data: null }
}
